// File: services/recipe.js
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin/intro-screen`;

export const GetScreenListApi = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: JSON.stringify({ action: "get" }) }),
    });

    if (!response.ok) throw new Error("Failed to fetch blog list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

export const handleDeleteScreen = async (recipeId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this Screen?")) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: JSON.stringify({ action: "delete", _id: recipeId }) }),
      });

      const data = await response.json();
      if (data.success) toast.success("Screen deleted successfully");
      else toast.warning("Screen deleted, but response was unexpected");
      refreshCallback();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};

export const submitScreenApi = async (screenData) => { 
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify({
      action: screenData._id ? "edit" : "add",
      _id: screenData._id,
      title: screenData.title,
      subtitle: screenData.subtitle
    }));

    if (screenData.imageFile) {
      formData.append("image", screenData.imageFile);
    }

    const response = await fetch(url, { method: "POST", body: formData });
    const result = await response.json();

    if (result.success || response.status === 201) {
      toast.success(screenData._id ? "Screen updated successfully" : "Screen added successfully");
      return result;
    } else {
      toast.error(result.message || "Failed to save Screen");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the Screen");
    return null;
  }
};

export const getScreenByIdApi = async (id) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: JSON.stringify({ action: "getById", _id: id }) }),
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load screen");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
